import React from 'react';

const ArrowDiagonal = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		className='arrow-long-right'
		{...props}
	>
		<g>
			<polygon
				points="2 2 2 5 14.87 5 2 17.88 2 20 4.12 20 16.94 7.18 16.94 20 20 20 20 2 2 2"
			/>
		</g>
	</svg>
);

export default ArrowDiagonal;
